export function padDate(value,type) {
    if(value){
        let [datePart, timePart] = value.split(' ');
        let [year, month, day] = datePart.split('-');

        month = month.padStart(2, '0');
        day = day.padStart(2, '0');

        let formattedDate = `${year}-${month}-${day}`;

        if (timePart) {
            return `${formattedDate} ${timePart}`;
        }

        // 如果没有时间部分，获取当前的时分秒
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');

        const currentTime = `${hours}:${minutes}:${seconds}`;
        if (type && type === 'date') {
            return formattedDate;
        } else {
            return `${formattedDate} ${currentTime}`;
        }
    }else{
        return ''
    }
}
export function formatNumberWithUnit(num) {
    if (typeof num !== 'number' || isNaN(num)) {
        throw new Error('输入必须是一个有效的数字');
    }
    if (num < 10000) {
        // 不足 10000，保留原样
        return num.toString();
    } else if (num >= 10000 && num < 1000000) {
        // 10000 到 999999，转换为 w（万），保留四位小数
        let value = (num / 10000).toFixed(4).toString();
        // 去掉末尾的零和小数点
        return value.replace(/(\.\d*?[0-9])0+$/, '$1').replace(/\.0$/, '') + 'w';
    } else {
        // 1000000 以上，转换为 m（百万），保留六位小数
        let value = (num / 1000000).toFixed(6).toString();
        // 去掉末尾的零和小数点
        return value.replace(/(\.\d*?[0-9])0+$/, '$1').replace(/\.0$/, '') + 'm';
    }
}
// 深度比较两个值是否相等
export function isEqual(oldValue, newValue) {
    // 处理 null 和 undefined
    if (oldValue === null || oldValue === '' || oldValue === undefined ||
        (Array.isArray(oldValue) && oldValue.length === 0) || newValue === null || newValue === '' || newValue === undefined ||
        (Array.isArray(newValue) && newValue.length === 0)) {
        if (
            (oldValue === null || oldValue === '' || oldValue === undefined ||
                (Array.isArray(oldValue) && oldValue.length === 0)
            ) &&
            (newValue === null || newValue === '' || newValue === undefined ||
                (Array.isArray(newValue) && newValue.length === 0))
        ) {
            return true;
        } else {
            return false
        }
    }
    // 处理 NaN
    if (Number.isNaN(oldValue) && Number.isNaN(newValue)) {
        return true;
    }
    // 处理 Symbol
    if (typeof oldValue === 'symbol' && typeof newValue === 'symbol') {
        return oldValue.toString() === newValue.toString();
    }
    // 处理函数
    if (typeof oldValue === 'function' && typeof newValue === 'function') {
        return oldValue.toString() === newValue.toString();
    }
    // 处理数字和数字字符串
    if (isNumberOrNumberString(oldValue) && isNumberOrNumberString(newValue)) {
        return Number(oldValue) === Number(newValue);
    }
    // 处理非对象类型（如字符串、数字、布尔值）
    if (typeof oldValue !== 'object') {
        return oldValue === newValue;
    }
    // 处理数组
    if (Array.isArray(oldValue) && Array.isArray(newValue)) {
        if (oldValue.length !== newValue.length) return false;
        for (let i = 0; i < oldValue.length; i++) {
            if (!isEqual(oldValue[i], newValue[i])) return false;
        }
        return true;
    }
    // 处理对象
    const oldKeys = Object.keys(oldValue);
    const newKeys = Object.keys(newValue);
    if (oldKeys.length !== newKeys.length) return false;
    for (const key of oldKeys) {
        if (!newKeys.includes(key) || !isEqual(oldValue[key], newValue[key])) {
            return false;
        }
    }
    return true;
}
function isNumberOrNumberString(value) {
    if (typeof value === 'number') return true;
    if (typeof value === 'string') {
        // 判断字符串是否可以转换为数字（排除空字符串）
        return value.trim() !== '' && !isNaN(Number(value));
    }
    return false;
  }